import { Fragment } from "react";
import { Chip, Tooltip } from "@mui/material";
import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";
import { useTranslation } from "react-i18next";
import { messages } from "../../../../../../locales/messages";
import { reviewTokens } from "../../../theme";

export interface RevertChipsProps {
  isRevertCr: boolean;
  wasRevertedLater: boolean;
  withTooltip?: boolean;
  withIcon?: boolean;
}

const chipSx = {
  fontWeight: 500,
  color: reviewTokens.slate600,
  borderColor: reviewTokens.slate300,
  bgcolor: reviewTokens.slate50,
};

export function RevertChips({
  isRevertCr,
  wasRevertedLater,
  withTooltip,
  withIcon,
}: RevertChipsProps) {
  const { t } = useTranslation();

  const renderChip = (label: string, icon: JSX.Element) => {
    const chip = (
      <Chip
        size="small"
        variant="outlined"
        icon={withIcon ? icon : undefined}
        label={label}
        sx={chipSx}
      />
    );
    return withTooltip ? <Tooltip title={label}>{chip}</Tooltip> : chip;
  };

  return (
    <Fragment>
      {isRevertCr
        ? renderChip(
            t(messages.Reverts_Earlier_Change()),
            <UndoOutlinedIcon sx={{ fontSize: 12 }} />,
          )
        : null}
      {wasRevertedLater
        ? renderChip(
            t(messages.Reverted_By_Later_Change()),
            <ReplayOutlinedIcon sx={{ fontSize: 12 }} />,
          )
        : null}
    </Fragment>
  );
}
